export const getCustomAttributesQuery = () => {
	const payload = `query customAttributeNames {
        customAttributeNames (
            input: {
                persona: {
                    type: "SUPPLIER"
                }
            }
        ) {
            edges {
                node {
                    names {
                        id
                        name
                    }
                }
            }
        }
    }`
	return payload;
};
